import React, { useEffect, useState } from "react";
import MainHeader from "../../components/mainheader";
import MainContainer from "../../components/maincontainer";
import manage from "../../assets/manageico.svg";
import Import from "../../assets/import.svg";
import Report from "../../assets/reports.svg";
import Create from "../../assets/create.svg";
import { useNavigate } from "react-router-dom";
import Img from "../../assets/tableimg.png";
import ContestTable from "../../components/tables/contest-table";
import { useSelector, useDispatch } from "react-redux";
import {
	LoadMore,
	LoadingLoader,
	MainPaginate,
} from "../../components/buttons/button";
import View from "../../assets/view.svg";
import { manageContestQuestions } from "../../data/Reducers/ContestReducer";
import CreateCategory from "../../components/modals/create-category";
import Main from "../../assets/main.svg";
import SubCat from "../../assets/subcat.svg";

const Contest = () => {
	const [modal, setModal] = useState(""),
		navigate = useNavigate();
	const handleClose = () => {
		setModal("");
	};
	const Arr = [
		{
			title: "Main category",
			img: Main,
			bg: "#F7F8FF",
			action: () => setModal("create-category"),
		},
		{
			title: "sub category",
			img: SubCat,
			bg: "#F7FFF7",
			action: () => setModal("create-sub-category"),
		},
		{
			title: "Create Contest",
			img: manage,
			bg: "#FFF7F7",
			action: () => navigate("/contest/create-contest"),
		},
		{
			title: "Create Questions",
			img: Create,
			bg: "#FFF2F9",
			action: () => navigate("/contest/create-question"),
		},
		{
			title: "View Questions",
			img: View,
			bg: "#FFFFF7;",
			action: () => navigate("/contest/questions"),
		},
		{
			title: "Import Questions",
			img: Import,
			bg: "#F7F8FF",
			action: () => navigate("/contest/import-questions"),
		},
		{
			title: "Question report",
			img: Report,
			bg: "#F4FFF1",
			action: () => navigate("/contest/question-report"),
		},
	];
	const Headers = [
		"Name",
		"Start Date",
		"End Date",
		"Entry fee",
		"status",
		"Top Users",
		"Winners Prize",
		"Actions",
	];
	const tableData = [
		{
			img: Img,
			id: "25",
			name: "C . Name",
			start_date: "26/12/2008",
			end_date: "26/12/2008",
			entry_fee: "50 coins",
			active: true,
			users: "100",
			distributed: true,
		},
		{
			img: Img,
			id: "25",
			name: "C . Name",
			start_date: "26/12/2008",
			end_date: "26/12/2008",
			entry_fee: "50 coins",
			active: true,
			users: "100",
			distributed: true,
		},
		{
			img: Img,
			id: "25",
			name: "C . Name",
			start_date: "26/12/2008",
			end_date: "26/12/2008",
			entry_fee: "50 coins",
			active: false,
			users: "100",
			distributed: true,
		},
		{
			img: Img,
			id: "25",
			name: "C . Name",
			start_date: "26/12/2008",
			end_date: "26/12/2008",
			entry_fee: "50 coins",
			active: true,
			users: "100",
			distributed: false,
		},
		{
			img: Img,
			id: "25",
			name: "C . Name",
			start_date: "26/12/2008",
			end_date: "26/12/2008",
			entry_fee: "50 coins",
			active: true,
			users: "100",
			distributed: true,
		},
		{
			img: Img,
			id: "25",
			name: "C . Name",
			start_date: "26/12/2008",
			end_date: "26/12/2008",
			entry_fee: "50 coins",
			active: true,
			users: "100",
			distributed: true,
		},
	];

	let { contest } = useSelector(s => s),
		[data, setData] = useState(null),
		dispatch = useDispatch();

	useEffect(() => {
		dispatch(manageContestQuestions("get", null, "types"));
	}, [dispatch]);

	useEffect(() => {
		setData(contest?.types);
	}, [contest?.types]);

	let [range] = useState(10),
		[page, setPage] = useState(1),
		[loading, setLoading] = useState(null);

	const [itemOffset, setItemOffset] = useState(0);
	const endOffset = itemOffset + range;

	if (!data && !contest?.types) return <LoadingLoader />;

	const currentItems = data?.docs?.slice(itemOffset, endOffset);
	const pageCount = Math.ceil(data?.docs?.length / range);

	const handlePageClick = event => {
			const newOffset = (event.selected * range) % data?.docs?.length;
			setItemOffset(newOffset);
			setPage(1 + event?.selected);
		},
		handleLoadMore = async () => {
			setLoading("loadmore");
			let datum = { limit: data?.limit * data?.nextPage };
			await dispatch(manageContestQuestions("get", datum, "types"));
			setLoading(false);
		};

	return (
		<div>
			<MainHeader text={"Contest"} />
			<MainContainer>
				<div className="tw-grid lg:tw-grid-cols-4 md:tw-grid-cols-2 tw-gap-6">
					{Arr.map((item, i) => (
						<div
							key={i}
							onClick={item.action}
							style={{
								background: item.bg,
							}}
							className={`myShadow2 tw-rounded-md tw-cursor-pointer tw-flex tw-justify-center tw-items-center tw-h-28`}>
							<div>
								<img src={item?.img} alt={item?.title} className="tw-mx-auto" />
								<h4 className="tw-text-base sansation tw-mt-2 tw-font-bold tw-text-center tw-text-main tw-capitalize">
									{item.title}
								</h4>
							</div>
						</div>
					))}
				</div>
				<div className="tw-mt-10">
					<ContestTable data={currentItems || tableData} headers={Headers} />
					<div className="tw-mt-4 tw-flex tw-justify-center">
						<LoadMore
							next={page === pageCount && data?.hasNextPage}
							loading={loading === "loadmore"}
							handleLoadMore={handleLoadMore}
						/>
					</div>
					<div className="tw-mt-4 tw-flex tw-justify-center">
						{/* <Pagination /> */}
						<MainPaginate
							pageCount={pageCount}
							handlePageClick={handlePageClick}
						/>
					</div>
				</div>
			</MainContainer>
			{modal === "create-category" && (
				<CreateCategory handleClose={handleClose} subType="contest" />
			)}
			{modal === "create-sub-category" && (
				<CreateCategory
					handleClose={handleClose}
					type="sub category"
					subType="contest"
				/>
				// <CreateSubCategory handleClose={handleClose} />
			)}
		</div>
	);
};

export default Contest;
